// @ts-nocheck
/**
 * Helper function to convert time string to minutes since midnight
 */
export const timeToMinutes = (timeString: string): number => {
  if (!timeString) {
    return 0;
  }

  // Handle 12-hour format (e.g., "2:36 PM", "9:00 AM")
  const twelveHourMatch = timeString.match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/i);
  if (twelveHourMatch) {
    let hours = parseInt(twelveHourMatch[1]);
    const minutes = parseInt(twelveHourMatch[2]);
    const ampm = twelveHourMatch[3].toUpperCase();

    // Convert to 24-hour format
    if (ampm === 'AM' && hours === 12) {
      hours = 0;
    } else if (ampm === 'PM' && hours !== 12) {
      hours += 12;
    }

    return hours * 60 + minutes;
  }

  // Handle 24-hour format (e.g., "14:36", "09:00")
  const twentyFourHourMatch = timeString.match(/^(\d{1,2}):(\d{2})$/);
  if (twentyFourHourMatch) {
    const hours = parseInt(twentyFourHourMatch[1]);
    const minutes = parseInt(twentyFourHourMatch[2]);
    return hours * 60 + minutes;
  }

  return 0;
};

/**
 * Helper function to convert minutes back to time string
 */
export const minutesToTime = (minutes: number): string => {
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return `${hours.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}`;
};

/**
 * Convert 24-hour time to 12-hour format for display
 */
export const formatTimeForDisplay = (timeString: string): string => {
  if (!timeString) return '';

  // If it's already in 12-hour format, return as is
  if (timeString.match(/^\d{1,2}:\d{2}\s*(AM|PM)$/i)) {
    return timeString;
  }

  // Convert from 24-hour format to 12-hour format
  const [hours, minutes] = timeString.split(':');
  const hour = parseInt(hours);
  const ampm = hour >= 12 ? 'PM' : 'AM';
  const displayHour = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
  return `${displayHour}:${minutes} ${ampm}`;
};

/**
 * Helper function to check if a time falls within a time range
 */
export const isTimeInRange = (gameTime: string, startTime: string, endTime: string): boolean => {
  const gameMinutes = timeToMinutes(gameTime);
  const startMinutes = timeToMinutes(startTime);
  const endMinutes = timeToMinutes(endTime);

  return gameMinutes >= startMinutes && gameMinutes <= endMinutes;
};
